import styled from 'styled-components';
import { EditorContent, useEditor } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';
import { theme } from '../../styles/theme';
import {
  EmojiExtension,
  MentionExtension,
} from './ConversationInputExtensions';

interface IProps {
  content: string;
}

const StyledReadOnlyEditor = styled(EditorContent)`
  .ProseMirror:focus {
    outline: none;
  }

  .tiptap {
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    color: ${theme.colors.secondary900};
  }

  [data-type='mention'] {
    color: ${theme.colors.mainBlue};
  }

  [data-type='emoji'] {
    user-select: text;
    // font-family needs to be inorder as firefox differ from chrome
    font-family: 'Twemoji Mozilla', 'Apple Color Emoji', 'Segoe UI Emoji',
      'Segoe UI Symbol', 'Noto Color Emoji', 'EmojiOne Color', 'Android Emoji',
      sans-serif;
  }
`;

const ReadOnlyConversationMessage = ({ content }: IProps) => {
  const editor = useEditor({
    content,
    editable: false,
    extensions: [
      StarterKit.configure({
        heading: false,
        blockquote: false,
        code: false,
        codeBlock: false,
        strike: false,
      }),
      MentionExtension,
      EmojiExtension,
    ],
  });

  return <StyledReadOnlyEditor editor={editor} />;
};

export default ReadOnlyConversationMessage;
